import { ROUTE_MAP } from './url';

export const APARTMENT_ADAPTER = {
  studio: {
    label: 'studio_long',
    abbreviation: 'studio_short',
    bed: 0,
    wc: 0,
    scene: '691c21599d4e2e854cda4544',
    mini: '/assets/images/floorImg/studio.webp',
    url: 'studio',
  },
  '1pn': {
    label: 'one_bedroom_long',
    abbreviation: 'one_bedroom_short',
    bed: 1,
    wc: 1,
    scene: '691c21599d4e2e854cda4544',
    mini: '/assets/images/floorImg/1pn.webp',
    url: '1pn',
  },
  '1pn-plus': {
    label: 'one_bedroom_plus_long',
    abbreviation: 'one_bedroom_plus_short',
    bed: 1,
    wc: 1,
    scene: '691c21599d4e2e854cda4544',
    mini: '/assets/images/floorImg/1pn-plus.webp',
    url: '1pn-plus',
  },
  '2pn-1wc': {
    label: 'two_bedroom_long',
    abbreviation: 'two_bedroom_short',
    bed: 2,
    wc: 1,
    scene: '691c22439d4e2e854cda4844',
    mini: '/assets/images/floorImg/2pn-1wc.webp',
    url: '2bedroom-1wc',
  },
  '2pn-2wc': {
    label: 'two_bedroom_plus_long',
    abbreviation: 'two_bedroom_plus_short',
    bed: 2,
    wc: 2,
    scene: '691c22439d4e2e854cda4844',
    mini: '/assets/images/floorImg/2pn-2wc.webp',
    url: '2bedroom-2wc',
  },
  '3pn': {
    label: 'three_bedroom_long',
    abbreviation: 'three_bedroom_short',
    bed: 3,
    wc: 2,
    scene: '691c269d9d4e2e854cda4f82',
    mini: '/assets/images/floorImg/3pn.webp',
    url: '3bedroom',
  },
  '3pn-dualkey': {
    label: 'three_bedroom_dualkey_long',
    abbreviation: 'three_bedroom_dualkey_short',
    bed: 3,
    wc: 2,
    scene: '691c269d9d4e2e854cda4f82',
    mini: '/assets/images/floorImg/3pn-dualkey.webp',
    url: '3bedroom-dualkey',
  },
};

export const AMENITY_ADAPTER = {
  shophouse: {
    label: 'Shophouse',
    scene: '68fb00b9e62230d4b445417f',
    url: 'shophouse',
  },
  pool: { label: 'Hồ bơi', scene: '68fb00d0e62230d4b44541ac', url: 'pool' },
  playground: {
    label: 'Sân thể thao',
    scene: '68fb00c3e62230d4b4454193',
    url: 'playground',
  },
};

export const MAIN_MAP = {
  '691c1bc39d4e2e854cda3edb': {
    label: 'Tổng quan Aurora',
    short: 'Tổng quan',
    url: `/${ROUTE_MAP.overview.id}`,
  },
};

export const AMENITIES_MAP = {
  '691d74719d4e2e854cdb0f56': {
    label: 'Quảng trường',
    short: 'Quảng trường',
    url: `/${ROUTE_MAP.amenities.id}/quangtruong`,
  },
  '691d77749d4e2e854cdb1599': {
    label: 'Cổng chính',
    short: 'Cổng chính',
    url: `/${ROUTE_MAP.amenities.id}/congvao`,
  },
  '691d75019d4e2e854cdb102b': {
    label: 'Sân chơi trẻ em',
    short: 'Sân chơi trẻ em',
    url: `/${ROUTE_MAP.amenities.id}/sanchoitreem`,
  },
};

export const APARTMENT_MAP = {
  // 1PN Plus
  '691c21599d4e2e854cda4544': {
    label: 'Căn hộ 1PN Plus',
    short: '1PN+',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/tong-quan`,
  },
  '691c215b9d4e2e854cda4553': {
    label: 'Căn hộ 1PN+ - Nhà vệ sinh',
    short: '1PN+ - Nhà vệ sinh',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/nha-ve-sinh`,
  },
  '691c215d9d4e2e854cda4560': {
    label: 'Căn hộ 1PN+ - Phòng ngủ master',
    short: '1PN+ - Phòng ngủ master',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/phong-ngu`,
  },

  // 2PN
  '691c22439d4e2e854cda4844': {
    label: 'Căn hộ 2PN',
    short: '2PN',
    url: `/${ROUTE_MAP.interior.id}/2pn/tong-quan`,
  },
  '691c2b769d4e2e854cda579a': {
    label: 'Căn hộ 2PN - Phòng ngủ 1',
    short: '2PN - Phòng ngủ 1',
    url: `/${ROUTE_MAP.interior.id}/2pn/phong-ngu`,
  },
  '691c2b749d4e2e854cda578f': {
    label: 'Căn hộ 2PN - Nhà vệ sinh',
    short: '2PN - Nhà vệ sinh',
    url: `/${ROUTE_MAP.interior.id}/2pn/nha-ve-sinh`,
  },

  // 3PN
  '691c269d9d4e2e854cda4f82': {
    label: 'Căn hộ 3PN',
    short: '3PN',
    url: `/${ROUTE_MAP.interior.id}/3pn/tong-quan`,
  },
  '691c268a9d4e2e854cda4f50': {
    label: 'Căn hộ 3PN - Nhà vệ sinh',
    short: '3PN - Nhà vệ sinh',
    url: `/${ROUTE_MAP.interior.id}/3pn/nha-ve-sinh`,
  },
  '691c2bc69d4e2e854cda5839': {
    label: 'Căn hộ 3PN - Ban công',
    short: '3PN - Ban công',
    url: `/${ROUTE_MAP.interior.id}/3pn/ban-cong`,
  },
  '69129061306dc464b887ed69': {
    label: 'Căn hộ 3PN - Phòng ngủ',
    short: '3PN - Phòng ngủ',
    url: `/${ROUTE_MAP.interior.id}/3pn/phong-ngu`,
  },
};

export const SCENES_MAP = { ...MAIN_MAP, ...AMENITIES_MAP, ...APARTMENT_MAP };
